import { Divider, Drawer, List, ListItem, ListItemText } from '@mui/material'
import { DrawerProps } from '@mui/material/Drawer'
import React from 'react'
import NavigatorItem from './NavigatorItem'
import items from './navigationItems'
import { NavigatorItemCategory } from './styles'

interface NavigatorProps extends DrawerProps {
  isEditor: boolean
  onMenuClick?: () => void
}

const Navigator = (props: NavigatorProps) => {
  const { isEditor, onMenuClick, ...other } = props

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <NavigatorItemCategory>
          <img src="/images/logo_light.png" alt="logo" style={{ width: '100%' }} />
        </NavigatorItemCategory>

        {items.map(
          ({ id, editorOnly, children }) =>
            (!editorOnly || isEditor) && (
              <React.Fragment key={id}>
                <ListItem sx={{ pt: 2, pb: 2 }}>
                  <ListItemText sx={{ color: 'common.white' }}>{id}</ListItemText>
                </ListItem>
                {children.map(({ id: childId, icon, path, pattern }) => (
                  <NavigatorItem
                    key={childId}
                    title={childId}
                    icon={icon}
                    to={path}
                    pattern={pattern}
                    onClick={() => onMenuClick && onMenuClick()}
                  />
                ))}
                <Divider sx={{ mt: 2 }} />
              </React.Fragment>
            ),
        )}
      </List>
    </Drawer>
  )
}

export default Navigator
